import { render, staticRenderFns } from "./UserRoleEditModal.vue?vue&type=template&id=14b5e476&"
import script from "./UserRoleEditModal.vue?vue&type=script&lang=js&"
export * from "./UserRoleEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports